import { LOCALES, DEFAULT_LOCALE } from 'constants/app-config'

export const localeFromPath = () => {
  const locale = global.location.pathname.split('/')[1]
  return LOCALES.includes(locale) ? locale : DEFAULT_LOCALE
}
